<p-avatarGroup styleClass="justify-content-end" [attr.data-testid]="uid">
    <ng-container *ngFor="let userDetail of userDetails.slice(0, maxShown)">
    <ng-template #popTemplate>
        <div class="d-flex">
            <p-avatar size="xlarge" shape="circle" [image]="'data:image/jpeg;base64,' + userDetail.profilePicture"></p-avatar>
            <div class="ms-3">
                <div class="mb-3">{{ userDetail.fullName }}</div>
                <div>{{ userDetail.email }}</div>
            </div>
        </div>
    </ng-template>
    <p-avatar
        styleClass="mz-medium-avatar"
        [popover]="popTemplate"
        triggers="mouseenter:mouseleave"
        shape="circle"
        [image]="'data:image/jpeg;base64,' + userDetail.profilePicture"
    ></p-avatar>
    </ng-container>
</p-avatarGroup>
